import React from 'react'
import { useNavigate } from 'react-router-dom'
import { TableProps } from './types'
import {
  TableStyle,
  Tr,
  Th,
  Td,
  NotFoundWrapper,
  NotFoundContent,
  NotFoundImg,
  NotFoundTitle,
  NotFoundText,
  NotFoundButton,
} from './styles'
import NoDataImg from '../../../assets/img/no-data.png'

const Table = ({
  columns,
  dataSource,
  goBackButtonVisible = true,
  guideNoData = true,
  loading = false,
}: TableProps) => {
  const navigate = useNavigate()

  return (
    <>
      <TableStyle>
        <tbody>
          <tr>
            {columns.map((column, index) => (
              <Th key={index}>{column.title}</Th>
            ))}
          </tr>
          {dataSource.map((data, index) => (
            <Tr key={index}>
              {columns.map((column, index) => (
                <Td key={index} style={column.style}>
                  {data[column.dataIndex]}
                </Td>
              ))}
            </Tr>
          ))}
        </tbody>
      </TableStyle>

      {dataSource.length === 0 && guideNoData && !loading ? (
        <NotFoundWrapper>
          <NotFoundContent>
            <NotFoundImg alt="notFoundImg" src={NoDataImg} />
            <br />
            <NotFoundTitle>No data found!</NotFoundTitle>
            <NotFoundText>Oops something went wrong.</NotFoundText>
            {goBackButtonVisible && (
              <NotFoundButton
                onClick={() => {
                  navigate(-1)
                }}
              >
                Back
              </NotFoundButton>
            )}
          </NotFoundContent>
        </NotFoundWrapper>
      ) : null}
    </>
  )
}

export default Table
